import { render } from "./carouselComp.vue?vue&type=template&id=2c210e73&ts=true"
import script from "./carouselComp.vue?vue&type=script&lang=ts"
export * from "./carouselComp.vue?vue&type=script&lang=ts"

import "./carouselComp.vue?vue&type=style&index=0&id=2c210e73&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__